// File Name filter for the Library / Archive / Videos tables (Redmine #264008).
//
// `file_name` is the upload sheet a record came from (e.g.
// "088_ARTS-Econ_July-Aug2026_189_v4_21Oct2026.xlsx"). It travels as a
// reserved top-level key on the table's filterOptions --
//   { search, filters, gate, sortBy_v, fileName: { value, match } }
// -- so it reaches the list request, the export (module_inputs) and Bulk
// Edit's "all filtered" selection unchanged. The backend answers it with a
// Mongo match (exact, or anchored + escaped "starts with") and, while it is
// applied, does not apply search or the other filters.

export const FILE_NAME_MATCH_OPTIONS = [
  { value: "exact", label: "Exact" },
  { value: "prefix", label: "Starts with" },
];

// -> { value, match } or null when there is nothing to filter on.
export const normalizeFileNameFilter = (spec) => {
  if (!spec || typeof spec !== "object" || typeof spec.value !== "string") {
    return null;
  }
  const value = spec.value.trim();
  if (!value) return null;
  return { value, match: spec.match === "prefix" ? "prefix" : "exact" };
};

export const hasFileNameFilter = (filterOptions) =>
  Boolean(normalizeFileNameFilter(filterOptions?.fileName));

// Returns filterOptions with the file-name filter set (or removed for null /
// blank), leaving every other key untouched.
export const withFileNameFilter = (filterOptions, spec) => {
  const { fileName: _previous, ...rest } = filterOptions || {};
  const normalized = normalizeFileNameFilter(spec);
  return normalized ? { ...rest, fileName: normalized } : rest;
};
